import React, { Component } from "react"

/* Constants */
import { utils, closed, env } from '../constants'

/* Picture */
import { Card } from "../components"
import { GAME, INSURANCE } from "../constants/status"

/* Widget Player Cards */
class PlayerCards extends Component {

    helper = (ind, game) => {

        const { playerData } = this.props

        const { status, selected, playerBox } = playerData

        return (
            <div className="player-box-helper">
                {
                    (status === GAME || status === INSURANCE) && selected && (ind === null || ind === playerBox) ?
                        <img className="arrow" src={`${env.endpoint}/images/arrow.png`} alt="arrow" />
                        : null
                }
            </div>
        )

    }

    boxCards = (cards, ind = null) => {

        if (!Array.isArray(cards)) {
            return null
        }

        const array = utils.get_unique_values(cards, "uuid")

        const { playerData } = this.props
        const { box, playerGame, blackjack,playerBox, selected, isWin, boxStand } = playerData

        let isBlacjack = blackjack
        const isStand = ind !== null ? Array.isArray(boxStand) ? boxStand[ind] : false : !Array.isArray(boxStand) ? boxStand : false

        const game = ind === null ? playerGame : playerGame[ind]
        const bust = game && game.score[0] && game.score[0] > 21

        let score = ''
        game && game.score && game.score.forEach((item, index) => {
            if (!index) {
                score += item
            } else {
                score += `/${item}`
            }
        })

        if (array.length === 2 && game && game.score && game.score[0] === 21 && ind === null) {
            isBlacjack = true
        }

        let style = ""
        if (score.length > 4) {
            style = "smaller"
        } else if (score.length > 2) {
            style = "small"
        }

        const win = isWin ?
            ind === null ?
                isWin : Array.isArray(isWin)
                    ? isWin[ind]
                    : false
            : false

        const cardsStyle = ind === 0 ? "first-box" : ""
        const additionalStyle = (box === 0 || box === 1) ? "right-position" : ""

        return (
            <div className={`player-cards ${cardsStyle}`} key={`box-cards-${ind}`} style={{ width: array.length * 35 + 35 }}>

                {isBlacjack ?
                    <img className="bj-icon" src={`${env.endpoint}/images/bj-icon.png`} alt="bj" />
                    :
                    game ?
                        <div className={`player-box-inform ${style}`}>
                            {win ?
                                <div className={`win-block ${additionalStyle}`}>
                                    <img src={`${env.endpoint}/images/rate/trophy.png`} alt="trophy" />
                                    <p>WIN</p>
                                </div>
                                : bust ? <img className={`bust-icon ${additionalStyle}`} src={`${env.endpoint}/images/rate/bust.png`} alt="bust" />
                                    : isStand ? <div className={`win-block ${additionalStyle}`}>
                                        <img src={`${env.endpoint}/images/rate/stand.png`} alt="stand" />
                                    </div>
                                        : selected && (ind === null || ind === playerBox) ? <div className={`box-spinner-loader ${additionalStyle}`} />
                                            : null}
                            <p>{score}</p>
                        </div>
                        : null
                }

                {array.map((card, index) => {

                    const key = card.uuid


                    let style = {
                        marginLeft: index === 0 ? 0 : -35,
                        marginTop: -(index * 20),
                        zIndex: index + 1
                    }

                    if ((window.innerWidth < 600 && window.innerWidth < window.innerHeight) && (box === 0 || box === 1)) {
                        style = {
                            marginRight: index === 0 ? 0 : -35,
                            marginTop: -(index * 20),
                            zIndex: index + 1
                        }
                    }

                    return (
                        <div className={`player-card`} key={`d-${key}`} style={style}>
                            <div className={`player-flip-card open`}>
                                <div className="player-flip-card-inner">
                                    <div className="player-flip-card-front">
                                        <img src={closed.image} alt="Closed" />
                                    </div>
                                    <div className={`player-flip-card-back`}>
                                        <Card data={card.name} />
                                    </div>
                                </div>
                            </div>
                            {index === array.length - 1 ? this.helper(ind, game) : null}
                        </div>
                    )

                })}
            </div>
        )

    }

    render = () => {

        const { playerData } = this.props
        const { box, cards } = playerData

        const tempCards = [...cards]

        const twoBox = tempCards && tempCards[0] && Array.isArray(tempCards[0])

        let style = twoBox ? "two-box" : ""

        if (box === 0 || box === 1) {
            style += " right-cards"
        }

        if (box === 3 || box === 4) {
            style += " left-cards"
        }

        return (
            <div className={`rate-cards ${style}`}>
                <div className={`player-container`}>

                    {
                        twoBox ?
                            tempCards.map((array, ind) => {
                                return this.boxCards(array, ind)
                            })
                            :
                            this.boxCards(tempCards)
                    }

                </div>
            </div>
        )
    }

}

export default PlayerCards